import { render, staticRenderFns } from "./PlayerItem.vue?vue&type=template&id=b1bff19e&"
import script from "./PlayerItem.vue?vue&type=script&lang=js&"
export * from "./PlayerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports